import { Component, Prop } from 'vue-property-decorator'
import { GForm } from '@/components/forms/GForm'

@Component
export class GenioView extends GForm {
    @Prop({ type: Object, default: () => ({}) }) process!: any

    async updateProcess (fields) {
      if (!fields?.id) return
      await this.pushData({
        model: 'Process',
        fields,
      })
    }
}
